import { render, staticRenderFns } from "./AuditLogIndexComponent.vue?vue&type=template&id=036b8b11"
import script from "./AuditLogIndexComponent.vue?vue&type=script&lang=js"
export * from "./AuditLogIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports